export default "__VITE_PUBLIC_ASSET__1ee4f5ed__"